/* ProgressComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ProgressRenderer");

class ProgressComponent extends EventEmitter {
    constructor(data) {
        super();
        this._data = data;
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this._renderer;
    }

    get rootElem() {
        return this._renderer.getRootElement();
    }

    set "$teve.ui.context"(context) {
        this._context = context;
    }

    shutdown() {
        const shutDowns = [this._renderer?.shutdown() || Promise.resolve()];

        return Promise.all(shutDowns).then(() => {
            this.removeAllListeners();
            this._renderer = undefined;
        });
    }

    reject(error) {
        this._context.reject(error);
    }

    resolve(data) {
        this._context.resolve(data);
    }

    abortProgress() {
        this.reject({aborted: true});
    }

    close() {
        this.reject({closed: true});
    }
}

module.exports = ProgressComponent;
